import { render, staticRenderFns } from "./agentLogin.vue?vue&type=template&id=1cb74e2c&scoped=true&"
import script from "./agentLogin.vue?vue&type=script&lang=js&"
export * from "./agentLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb74e2c",
  null
  
)

export default component.exports